const MemberStatusEnum = {
    Historical: 'Historical',
    Active: 'Active'
}

const BallotStatusEnum = {
    Current: 'O',
    Closed: 'C',
    All: 'A'
}

export const BallotHeaderInfo =
    [{ 'title': 'Committee', 'hasSorting': true, 'className': "", "sortKey": 'Committee', 'orderBy': 0, 'orderByIcon': 1 },
    { 'title': 'Letter Ballot', 'hasSorting': true, 'className': "", 'sortKey': 'LetterBallot', 'orderBy': 0, 'orderByIcon': 0 },
    { 'title': 'Issue Date', 'hasSorting': true, 'className': "", 'sortKey': 'IssueDate', 'orderBy': 0, 'orderByIcon': 0 },
    { 'title': 'Closing Date', 'hasSorting': true, 'className': "", 'sortKey': 'ClosingDate', 'orderBy': 0, 'orderByIcon': 0 },
    { 'title': 'Society Review', 'hasSorting': true, 'className': "", 'sortKey': 'SocietyReview', 'orderBy': 0, 'orderByIcon': 0 },
    { 'title': 'Staff Manager', 'hasSorting': true, 'className': "", 'sortKey': 'StaffManager', 'orderBy': 0, 'orderByIcon': 0 },
    { 'title': 'Supplemental Document', 'hasSorting': true, 'className': "", 'sortKey': 'SuppDocFileName', 'orderBy': 0, 'orderByIcon': 0 }
    ]

export const BallotItemsHeader =
    [{ 'title': 'Item', 'hasSorting': true, 'width': '10%', 'className': "", "sortKey": 'itemnumber', 'orderBy': 1, 'orderByIcon': 1 },
    { 'title': 'Sub', 'hasSorting': false, 'width': '10%', 'className': "", 'sortKey': 'subnumber', 'orderBy': 0, 'orderByIcon': 0 },
    { 'title': 'Description', 'hasSorting': false, 'width': '50%', 'className': "", 'sortKey': '', 'orderBy': 0, 'orderByIcon': 0 },
    { 'title': 'Supporting Document', 'hasSorting': false, 'width': '20%', 'className': "", 'sortKey': 'suppdocfilename', 'orderBy': 0, 'orderByIcon': 0 },
    ]

export const BallotAdminDropDown = [
    { key: 1, text: "Current Ballots", value: 'O' },
    { key: 2, text: "Closed Ballots", value: 'C' },
    { key: 3, text: "All Ballots", value: 'A' }]

export const Const_Status = 'Status';

export const Const_Status_Item = { 'title': 'Status', 'hasSorting': true, 'className': "", 'sortKey': 'Status', 'orderBy': 0, 'orderByIcon': 0 };

export const Default_Sort_Column = 'COMMITTEE';

export const Default_Sort_Order = 'Desc';

export const Const_Current = 'Current';

export const Const_Closed = 'Closed';

export { MemberStatusEnum, BallotStatusEnum }


export const VoteHistoryHeader =
    [{ 'title': 'Vote Date', 'hasSorting': true, 'className': "", "sortKey": 'SubmissionDate', 'orderBy': 1, 'orderByIcon': 1 },
    { 'title': 'Letter Ballot', 'hasSorting': true, 'className': "", 'sortKey': 'BallotNumber', 'orderBy': 0, 'orderByIcon': 0 },
    { 'title': 'Ballot Submission Status', 'hasSorting': true, 'className': "", 'sortKey': 'VoteStatus', 'orderBy': 0, 'orderByIcon': 0 },
    ]


export const ViewHisstoryStatusEnum = {
    '-1': 'ALL',
    '0': 'Saved, Not Submitted',
    '1': 'Submitted',
    '2': 'Not Submitted'
}

export const ViewVoteHisstoryStatusDropDown = [
    { key: -1, text: "ALL", value: -1 },
    { key: 2, text: "Not Submitted", value: 2 },
    { key: 1, text: "Submitted", value: 1 },
    { key: 0, text: "Saved, Not Submitted", value: 0 }
]

export const VoteDetailsHeader =
    [{ 'title': 'Item No.', 'hasSorting': true, 'className': "", "sortKey": 'ItemNumber', 'orderBy': 1, 'orderByIcon': 1 },
    { 'title': 'Vote', 'hasSorting': true, 'className': "", 'sortKey': 'VoteDescription', 'orderBy': 0, 'orderByIcon': 0 },
    { 'title': 'Vote Comment/Statement', 'hasSorting': false, 'className': "", 'sortKey': 'VoteDescription', 'orderBy': 0, 'orderByIcon': 0 },
    { 'title': 'Comment File', 'hasSorting': false, 'className': "", 'sortKey': 'FileName', 'orderBy': 0, 'orderByIcon': 0 }
    ]

export const Const_VoteDetails_Default_Sort_Column = 'ItemNumber';
export const Const_VoteDetailsDefault_Sort_Order = 'Asc';
